<template>
  <p class="logo-wrap">
    <img src="./logo.png" alt="logo">
  </p>
</template>

<script>
export default {
  name: 'Logo',
}
</script>

<style lang="scss" scoped>
.logo-wrap {
  position: absolute;
  width: 19.2rem;
  top: 0.25rem;
  left: 0;
  img {
    width: 4.9rem;
    height: 2rem;
  }
}
</style>
